import { CSSProperties } from 'react';

export const ProgressZonedropZone = {
    border: '1px solid #C9CACA',
    borderRadius: '6px',
    height: '36rem',
    textAlign: 'center',
    background: '#F6F6F6',
    padding: '2rem',
    overflowY: 'auto',
    marginBottom: '1.25rem',
};

/**
 * Returns the inline style for the progress description.
 *
 * @param {string} ev - The progress event.
 * @returns {object} - The inline style object.
 */
export const ProgressZoneprogressDesc = (ev: string): object => {
    const progressStyle = {
        fontFamily: "'Poppins'",
        fontStyle: 'normal',
        fontWeight: `${ev === 'success' || ev === 'failed' ? 'bold' : ''}`,
        fontSize: '13px',
        lineHeight: '24px',
        fontFeatureSettings: "'pnum' on, 'lnum' on",
        color: `${ev === 'wait' ? '#6B6B6B' : '#3A3A3A'}`,
        whiteSpace: 'nowrap',
        textWrap: 'wrap',
        overflowWrap: 'anywhere',
    };

    return progressStyle;
};

/**
 * Returns the inline style for the progress status.
 *
 * @param {string} ev - The progress event.
 * @returns {object} - The inline style object.
 */
export const ProgressZoneprogressStatus = (ev: string): object => {
    /**
     * Returns the icon name based on the progress event.
     *
     * @param {string} ev - The progress event.
     * @returns {string} - The icon name.
     */
    const colorPick = (event: string): string => {
        switch (event) {
            case 'wait':
                return '#929292';
            case 'success':
                return '#1E56DA';
            case 'failed':
                return '#D00B28';
            case 'loading':
                return '#3A3A3A';
            default:
                return '#3A3A3A';
        }
    };

    const style = {
        fontFamily: "'Poppins'",
        fontStyle: 'normal',
        fontWeight: 'bold',
        fontSize: '13px',
        lineHeight: '24px',
        fontFeatureSettings: "'pnum' on, 'lnum' on",
        color: `${colorPick(ev)}`,
        whiteSpace: 'nowrap',
        textWrap: 'wrap',
        overflowWrap: 'anywhere',
    };

    return style;
};

export const ProgressZonedummyProgress = [
    'wait',
    'success',
    'failed',
    'loading',
];

export const iconsPicker = (ev: string): string => {
    switch (ev) {
        case 'success':
            return 'CheckIconBlue.svg';
        case 'failed':
            return 'TypeWarning.svg';
        default:
            return '';
    }
};

export const ProgressZoneprogressColor = {
    height: '0.5rem',
    background: '#1E56DA',
    borderRadius: '10px',
    position: 'relative',
    zIndex: 2,
};

export const ProgressZonebaseColor = {
    height: '0.5rem',
    background: '#EEEEEE',
    borderRadius: '10px',
    position: 'relative',
    top: '-0.5rem',
    zIndex: 1,
};

export const ProgressZoneprogressText = {
    maxWidth: '70%',
    textAlign: 'left',
    position: 'relative',
};

/**
 * Returns the background color based on the progress event.
 *
 * @param {string} ev - The progress event.
 * @returns {string} - The background color.
 */
export const ProgressZonebackgroundProgress = (ev: string): string => {
    switch (ev) {
        case 'wait':
            return '#E7E7E7';
        case 'failed':
            return '#fde6e5';
        default:
            return 'white';
    }
};

export const ProgressZoneBoxParent = (index: any): object => {
    const ProgressZoneBoxParent = {
        padding: '1rem 2rem',
        display: 'flex',
        justifyContent: 'space-between',
        marginTop: `${index > 0 && '1rem'}`,
        minHeight: '5rem',
        border: ``,
        borderRadius: '10px',
    };
    return ProgressZoneBoxParent;
};

export const ProgressZoneBoxStepParent = {
    position: 'relative',
    top: '50%',
    transform: 'translateY(-50%)',
};

export const ProgressZoneBoxDesc = {
    position: 'relative',
    top: '50%',
    transform: 'translateY(-50%)',
};

export const ProgressZoneIconsPicker: CSSProperties = {
    width: '1.5rem',
    position: 'relative',
    top: '0.3rem',
    left: '0.3rem',
};

export const ProgressZoneProgressStatus = {
    padding: '0rem 2rem',
    position: 'relative',
    top: '-2rem',
    marginTop: '1rem',
};

export const ProgressZoneDataProgress = (data: any, index: any): object => {
    const ProgressZoneDataProgress = {
        padding: '1rem 2rem',
        display: 'flex',
        justifyContent: 'space-between',
        marginTop: `${index > 0 && '1rem'}`,
        minHeight: '5rem',
        border: `${data === 'failed' ? '1px solid #D00B28' : ''}`,
        borderRadius: '10px',
    };
    return ProgressZoneDataProgress;
};

export const ProgressZoneBoxProgressText = {
    position: 'relative',
    top: '50%',
    transform: 'translateY(-50%)',
};

export const ProgressZoneBoxDescText = {
    position: 'relative',
    top: '50%',
    transform: 'translateY(-50%)',
};

export const ProgressZoneSecondIconPicker: CSSProperties = {
    width: '1.5rem',
    position: 'relative',
    top: '0.3rem',
    left: '0.3rem',
};

export const ProgressZoneLoadingBar = {
    padding: '0rem 2rem',
    position: 'relative',
    top: '-2rem',
    marginTop: '1rem',
};

export const ProgressZoneFailedUpload = {
    position: 'relative',
    left: '0',
    margin: 'auto',
};

export const ProgressZonePresumeUpload = {
    position: 'relative',
    left: '0',
    margin: 'auto',
};
